/**
 * ACM Pošta — jádro mail.* žije tady; webmail UI je Codable šablona `webmail`.
 */
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { Inbox } from 'lucide-react';
import { CodableIcon } from '../../components/icons/CodableIcon';
import { Button, Card, CardContent, PageHeader } from '../../components/ui';
import { api } from '../../lib/api';

export default function MailPage() {
  const { t } = useTranslation();
  const { data } = useQuery({
    queryKey: ['codable', 'templates'],
    queryFn: () =>
      api.mcp<{ templates?: Array<{ id: string; label: string }> }>(
        'codable.template_list',
        { category: 'app' },
        { silent: true },
      ),
    staleTime: 60_000,
  });
  const hasTpl = (data?.templates ?? []).some((x) => x.id === 'webmail');

  return (
    <div className='max-w-2xl space-y-6'>
      <PageHeader
        title={t('mail.title', 'Pošta')}
        description={t(
          'mail.coreHint',
          'Jádro je MCP mail.* na ACM. Webmail se staví jako Codable projekt — lehký React/Vite/Tailwind, stejný stack jako ostatní appky.',
        )}
        icon={Inbox}
      />
      <Card>
        <CardContent className='space-y-3 p-5 text-sm text-gray-300'>
          <p>
            {t(
              'mail.codablePath',
              'Nový projekt v Codable → šablona Pošta (webmail). Volá jen mail.connect / mail.messages / mail.send. Stalwart, JMAP a SMTP zůstanou na platformě.',
            )}
          </p>
          <div className='flex flex-wrap gap-2'>
            <Link to='/modules/codable/new?template=webmail'>
              <Button variant='primary' icon={CodableIcon}>
                {t('mail.newCodable', 'Nový Codable projekt')}
              </Button>
            </Link>
            <Link to='/modules/stalwart'>
              <Button variant='secondary'>
                {t('mail.openStalwart', 'Stalwart instance')}
              </Button>
            </Link>
          </div>
          {!hasTpl && (
            <p className='text-xs text-amber-300'>
              {t('mail.tplMissing', 'Šablona webmail se v katalogu ještě neukazuje — až po deployi ACM.')}
            </p>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
